import { render, staticRenderFns } from "./Factures_Liste.vue?vue&type=template&id=490a4190&scoped=true&"
import script from "./Factures_Liste.vue?vue&type=script&lang=js&"
export * from "./Factures_Liste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a4190",
  null
  
)

export default component.exports